export const ENDPOINTS = {
  policy: "/api/policies",
  editorialTexts: "/api/editorial-text",
  teamMembers: "/api/team-members",
  team: "/api/team",
};
